import { Avatar, AvatarProps, SxProps } from '@mui/material';

interface MuiAvatarProps extends AvatarProps {
  sx?: SxProps;
}

export function MuiAvatar(props: MuiAvatarProps) {
  const { sx, ...rest } = props;

  return (
    <Avatar sx={{ ...sx }} {...rest}>
      {props.children}
    </Avatar>
  );
}
